import React, { useState, useEffect } from "react";
import { Modal, Input, Typography, message, Space, Tag } from "antd";
import styles from "./SaveViewModal.module.scss";

const { Text } = Typography;

const SaveViewModal = ({ open, onClose, onSave, entity, filters, activeTab }) => {
  const [name, setName] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (open && entity) {
      const yearStr = Array.isArray(filters?.yearRange) ? `${filters.yearRange[0]}-${filters.yearRange[1]}` : (filters?.yearRange || "all");
      setName(`${entity.name || "Unknown"} - ${yearStr}`);
    }
  }, [open, entity, filters]);

  const handleSave = async () => {
    if (!name.trim()) {
      message.error("Please enter a name for this view.");
      return;
    }
    setIsSaving(true);
    try {
      await onSave(name.trim());
      message.success("View saved successfully!");
      onClose();
    } catch (err) {
      console.error("Failed to save view:", err);
      message.error("Failed to save view. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      title="Save View"
      open={open}
      onCancel={onClose}
      onOk={handleSave}
      okText="Save View"
      confirmLoading={isSaving}
      destroyOnClose
    >
      <div className={styles.container}>
        <div className={styles.formGroup}>
          <label>View Name</label>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. MIT - Physics 2019-2024"
            maxLength={100}
            autoFocus
            onPressEnter={handleSave}
          />
        </div>
        
        <div className={styles.preview}>
          <div className={styles.previewTitle}>Preview of saved state:</div>
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <div><Text type="secondary">Entity:</Text> <Text strong>{entity?.name}</Text></div>
            <div><Text type="secondary">Tab:</Text> <Text style={{ textTransform: 'capitalize' }}>{activeTab}</Text></div>
            <div>
              <Text type="secondary">Filters:</Text>
              <div className={styles.tags}>
                {filters?.yearRange && (
                  <Tag>{Array.isArray(filters.yearRange) ? `${filters.yearRange[0]} - ${filters.yearRange[1]}` : filters.yearRange}</Tag>
                )}
                {filters?.geography && <Tag>Geo: {filters.geography}</Tag>}
                {filters?.metric && <Tag>Metric: {filters.metric}</Tag>}
                {filters?.collaboratorType && <Tag>Type: {filters.collaboratorType}</Tag>}
                {filters?.subjectArea && filters.subjectArea.length > 0 && (
                  <Tag>{filters.subjectArea.length} Subject Areas</Tag>
                )}
              </div>
            </div>
          </Space>
        </div>
      </div>
    </Modal>
  );
};

export default SaveViewModal;
